export const formatActivityLogs = (activityLogs = {}) => ({
  ...activityLogs,
  results: (activityLogs.results || []).map((result) => ({
    ...result,
    item: result.item || '',
  })),
});
